import React, { Ref, useState } from 'react'
import { DateInput, Calendar } from '@paypalcorp/pp-react'
import { useLocalizedContent } from '../../../hooks/useLocalizedContent'
import { useAppSelector } from '../../../store/hooks'
import { selectCloseDateAsObject } from '../../../store/slices/groupFormSlice'
import logger from '../../../utils/logger'
import { isCoverOnCreateFlowEnabled } from '../../../utils/features'

interface CloseDateProps {
  error?: string
  maxDate?: Date
  handleOnChange: Function
  closeDateRef?: Ref<HTMLInputElement>
}

const getMaxTargetDate = (maxDate: Date): Date => {
  if (maxDate) {
    return new Date(maxDate)
  }

  logger.error('CLIENT', { message: 'maxDate was undefined' })
  return new Date()
}

const GroupCloseDate = (props: CloseDateProps) => {
  const closeDate = useAppSelector(selectCloseDateAsObject)
  const [isCalendarVisible, setIsCalendarVisible] = useState(false)
  const wrapperRef: React.MutableRefObject<any> = React.useRef(null)
  const { getContent } = useLocalizedContent()

  const handleCalendarVisibility = (visibility: boolean) => {
    setIsCalendarVisible(visibility)
  }
  const handleDateSelection = (date: Date) => {
    props.handleOnChange(date?.toString())
    setIsCalendarVisible(false)
  }
  const today = new Date()
  const maximumTargetDate = getMaxTargetDate(props.maxDate)

  const yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  const isDateDisabled = (date: Date) => {
    const dateTime = date.getTime()

    return (
      dateTime < yesterday.getTime() || dateTime > maximumTargetDate.getTime()
    )
  }

  const calendarElm = (
    <Calendar
      selectedDate={closeDate}
      onSelection={handleDateSelection}
      calendarFrom={today}
      calendarTo={maximumTargetDate}
      isDateDisabled={isDateDisabled}
    />
  )

  return (
    <div ref={wrapperRef}>
      {/* <div ref={wrapperRef} is needed for calendar popup alignment */}
      <DateInput
        maskOptions={{ lazy: isCoverOnCreateFlowEnabled() }}
        name="closeDate"
        label={getContent('create.view.dateLabel')}
        calendar={calendarElm}
        selectedDate={closeDate}
        onSelection={handleDateSelection}
        isCalendarVisible={isCalendarVisible}
        onShowCalendar={handleCalendarVisibility}
        errorText={props.error}
        wrapperContainerRef={wrapperRef}
        data-testid="group-close-date-input"
        ref={props.closeDateRef}
      />
    </div>
  )
}
export default GroupCloseDate
